export default __webpack_public_path__ + "images/Q7.fd4e1e5.png";